import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { IconPlus, IconTrash03 } from "@pentabd/icons";
import { Button } from "@pentabd/ui";

import {
  InputDateControllerRow,
  InputTextRow,
  MultiFileRow,
} from "@components";

import { getAccess } from "@helpers/permissionController";
import { useUser } from "@hooks/useUser";
import { TENDER_NOTICE } from "..";

export const TenderNoticePaper = () => {
  const { control, register, setValue } = useFormContext();

  const { t } = useTranslation();

  const { user } = useUser();
  const { realm_roles: roles } = user || {};

  const {
    fields: tenderNoticeFields,
    append: tenderNoticeAppend,
    remove: tenderNoticeRemove,
  } = useFieldArray({
    control,
    name: "papersInfo",
  });

  return (
    <>
      {tenderNoticeFields.map((item: any, index) => {
        return (
          <div className="d-flex flex-column gap-6" key={index}>
            <MultiFileRow
              label="PROCUREMENT_CREATE.TENDER_NOTICE_PUBLICATION.FORM.TENDER_DOC"
              name={`papersInfo.${index}.${TENDER_NOTICE.NOTICE_DOCUMENT}`}
              control={control}
              setValue={setValue}
              register={register}
              fileDetails={["documentName", "date", "remarks", "memorialNo"]}
            />
            <InputTextRow
              label="PROCUREMENT_CREATE.TENDER_NOTICE_PUBLICATION.FORM.TENDER_PAPER_NAME"
              register={{
                ...register(`papersInfo.${index}.${TENDER_NOTICE.PAPER_NAME}`),
              }}
            />
            <InputDateControllerRow
              control={control}
              label="PROCUREMENT_CREATE.TENDER_NOTICE_PUBLICATION.FORM.TENDER_PAPER_DATE"
              register={{
                ...register(`papersInfo.${index}.${TENDER_NOTICE.PAPER_DATE}`),
              }}
              name={`papersInfo.${index}.${TENDER_NOTICE.PAPER_DATE}`}
            />
            <InputTextRow
              label="PROCUREMENT_CREATE.TENDER_NOTICE_PUBLICATION.FORM.TENDER_PUBLISH_LINK"
              register={{
                ...register(
                  `papersInfo.${index}.${TENDER_NOTICE.PUBLISH_NEWS_LINK}`,
                ),
              }}
            />
            <div className="row">
              <div className="col-lg-3"></div>
              <div className="col-lg-7 text-end">
                {getAccess(roles, "PROCUREMENT_HR") && (
                  <Button
                    htmlType="button"
                    type="danger"
                    fill="outline"
                    size="sm"
                    onClick={() => tenderNoticeRemove(index)}
                  >
                    <IconTrash03 size="20" fill="danger" />
                    {t(
                      "PROCUREMENT_CREATE.TENDER_NOTICE_PUBLICATION.FORM.DELETE_BUTTON_TEXT",
                    )}
                  </Button>
                )}
              </div>
            </div>
          </div>
        );
      })}

      {getAccess(roles, "PROCUREMENT_HR") && (
        <Button
          htmlType="button"
          type="light"
          fill="outline"
          onClick={() => tenderNoticeAppend({})}
          size="sm"
          className="w-max"
        >
          <IconPlus size="20" fill="dark" />
          {t(
            "PROCUREMENT_CREATE.TENDER_NOTICE_PUBLICATION.FORM.ADD_BUTTON_TEXT",
          )}
        </Button>
      )}
    </>
  );
};
